import React from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import { Grid, Switch, Typography } from '@mui/material'
import { useState } from 'react'
import useDebounce from 'utils/customHook/useDebounce'
import HelpParameter from './HelpParameter'
import withStatsHelp from 'assets/pictures/observatory/withStatsHelp.webp'

const WithStats = ({
    parameters = [],
    setParameters = () => {},
    getGlobalParameter = () => {},
    moduleParameters = [],
    setModuleParameters = [],
    getGlobalModuleParameter = () => {},
    isWidget = false,
    isGlobal = false,
}) => {
    const parameter = isWidget ? 'withStatsWidget' : 'withStats'
    const foundParameter = parameters.find(p => p.parameter === parameter)?.value
    const foundModuleParameter = moduleParameters.find(p => p.parameter === parameter)?.value

    const [withStats, setWithStats] = useState(foundParameter === 'true')
    const [moduleWithStats, setModuleWithStats] = useState(foundModuleParameter === 'true')

    useDebounce(() => {
        setParameters(prev => [
            ...prev.filter(p => p.parameter !== parameter),
            getGlobalParameter(parameter, `${withStats}`),
        ])
    }, 200, [withStats])

    useDebounce(() => {
        setModuleParameters(prev => [
            ...prev.filter(p => p.parameter !== parameter),
            getGlobalModuleParameter(parameter, `${moduleWithStats}`),
        ])
    }, 200, [moduleWithStats])

    return (
        <Grid container justifyContent='space-between' alignItems='flex-start' columnSpacing={1}>
            <Grid size={0.5}>
                <HelpParameter image={withStatsHelp} />
            </Grid>
            <Grid container direction='column' size='grow'>
                <Typography variant='normalFormTitle'>{i18n.abilityToViewEnvelopes}</Typography>
                <Typography variant='italicSubtitle'>
                    {i18n.currentlyAvailableEverywhereExceptForPluviometry}
                </Typography>
            </Grid>
            <Grid container size={3.25}>
                <Switch
                    checked={withStats}
                    onClick={() => setWithStats(prev => !prev)}
                    disabled={!isGlobal}
                />
            </Grid>
            {!!isWidget && (
                <Grid container size={3.25}>
                    <Switch
                        checked={moduleWithStats}
                        onClick={() => setModuleWithStats(prev => !prev)}
                    />
                </Grid>
            )}
            <Grid offset={!isWidget && !isGlobal && 3.25} size={0.5} />
        </Grid>
    )
}

WithStats.propTypes = {
    parameters: PropTypes.arrayOf(PropTypes.shape({})),
    setParameters: PropTypes.func,
    getGlobalParameter: PropTypes.func,
    moduleParameters: PropTypes.arrayOf(PropTypes.shape({})),
    setModuleParameters: PropTypes.func,
    getGlobalModuleParameter: PropTypes.func,
    isWidget: PropTypes.bool,
    isGlobal: PropTypes.bool,
}

export default WithStats
